import {
  Sparkles, Wrench, Zap, Hammer, Leaf, Home, Settings, Truck, Paintbrush, Bug,
  PenTool, Ruler, Wind, Scissors, CircuitBoard, Lock, Frame, CloudRain, Waves, Fence,
  Droplets, Flame, Plug, Fan, Tv, DoorOpen, Blinds, Pipette, Thermometer,
  Building2, Package, Warehouse, TreePine, Flower2, HardHat, Refrigerator,
  WashingMachine, AirVent, Shield, CheckCircle, Heart,
  // New 2026: Accounting, Signage & Printing, Phone Repair
  Calculator, Receipt, FileText, Briefcase, Banknote, Landmark, PieChart, Coins,
  Printer, Tag, Megaphone, Sticker, Image, Shirt,
  Smartphone, Tablet, Battery, BatteryCharging
} from "lucide-react";

// Icon mapping for categories (slug → lucide component)
export const iconMap = {
  'sparkles': Sparkles, 'wrench': Wrench, 'zap': Zap, 'hammer': Hammer,
  'leaf': Leaf, 'home': Home, 'tool': Settings, 'truck': Truck,
  'paint-roller': Paintbrush, 'shield': Bug, 'brush': PenTool, 'ruler': Ruler,
  'wind': Wind, 'scissors': Scissors, 'circuit-board': CircuitBoard, 'lock': Lock,
  'frame': Frame, 'cloud-rain': CloudRain, 'waves': Waves, 'fence': Fence,
  // New 2026
  'calculator': Calculator, 'printer': Printer, 'smartphone': Smartphone
};

// Category slug → gradient class
export const categoryGradients = {
  'home-cleaning': 'cleaning', 'plumbing': 'plumbing', 'electrical': 'electrical',
  'handyman': 'handyman', 'gardening-lawn': 'gardening', 'property-maintenance': 'property',
  'appliance-repair': 'appliance', 'moving-services': 'moving', 'home-renovation': 'renovation',
  'pest-control': 'pest', 'painting': 'painting', 'carpentry': 'carpentry',
  'ac-heat-pumps': 'hvac', 'hair-beauty': 'beauty', 'it-tech-services': 'tech',
  'security-cctv': 'security', 'flooring': 'flooring', 'roofing-gutters': 'roofing',
  'ai-services': 'ai', 'automotive-mechanics': 'automotive', 'pool-spa-services': 'pool',
  'fencing-gates': 'fencing', 'locksmith-services': 'locksmith', 'solar-ev-charging': 'solar',
  'event-services': 'event', 'photography-videography': 'photography', 'catering-food-services': 'catering',
  'equipment-furniture-hire': 'equipment', 'personal-wellness-services': 'wellness',
  'pet-services': 'pet', 'dj-mc-services': 'dj',
  // New 2026
  'accounting-tax': 'accounting', 'signage-printing': 'signage', 'phone-repair': 'phone-repair'
};

// Category hero images for detail pages
export const CATEGORY_HERO_IMAGES = {
  'plumbing': 'https://images.pexels.com/photos/6419128/pexels-photo-6419128.jpeg?auto=compress&cs=tinysrgb&w=1200',
  'electrical': 'https://images.pexels.com/photos/27928762/pexels-photo-27928762.jpeg?auto=compress&cs=tinysrgb&w=1200',
  'home-cleaning': 'https://images.unsplash.com/photo-1581578949510-fa7315c4c350?w=1200&q=80',
  'handyman': 'https://images.unsplash.com/photo-1745449563046-f75d0bd28f46?w=1200&q=80',
  'gardening-lawn': 'https://images.unsplash.com/photo-1767328796803-756a72608d5c?w=1200&q=80',
  'property-maintenance': 'https://images.unsplash.com/photo-1759753985489-11719e67dc7a?w=1200&q=80',
  'appliance-repair': 'https://images.unsplash.com/photo-1687793358564-f4a9e83f2ec0?w=1200&q=80',
  'moving-services': 'https://images.pexels.com/photos/7464722/pexels-photo-7464722.jpeg?auto=compress&cs=tinysrgb&w=1200',
  'home-renovation': 'https://images.unsplash.com/photo-1770838773417-08b18661c62f?w=1200&q=80',
  'pest-control': 'https://images.unsplash.com/photo-1758522965291-36664fbdac9c?w=1200&q=80',
  'painting': 'https://images.unsplash.com/photo-1563980372965-78b61bc2b8e6?w=1200&q=80',
  'carpentry': 'https://images.unsplash.com/photo-1772207896656-4210003d65ee?w=1200&q=80',
  'ac-heat-pumps': 'https://images.pexels.com/photos/20046692/pexels-photo-20046692.jpeg?auto=compress&cs=tinysrgb&w=1200',
  'hair-beauty': 'https://images.unsplash.com/photo-1560066984-138dadb4c035?w=1200&q=80',
  'it-tech-services': 'https://images.unsplash.com/photo-1518770660439-4636190af475?w=1200&q=80',
  'security-cctv': 'https://images.unsplash.com/photo-1558002038-1055907df827?w=1200&q=80',
  'flooring': 'https://images.unsplash.com/photo-1624574470112-46944be68409?w=1200&q=80',
  'roofing-gutters': 'https://images.unsplash.com/photo-1632759145351-1d592919f522?w=1200&q=80',
  'ai-services': 'https://images.unsplash.com/photo-1677442136019-21780ecad995?w=1200&q=80',
  'automotive-mechanics': 'https://images.unsplash.com/photo-1619642751034-765dfdf7c58e?w=1200&q=80',
  'pool-spa-services': 'https://images.unsplash.com/photo-1689968893328-cab5b1a4af8a?w=1200&q=80',
  'fencing-gates': 'https://images.unsplash.com/photo-1740482682683-309e6fb4898f?w=1200&q=80',
  'locksmith-services': 'https://images.pexels.com/photos/792034/pexels-photo-792034.jpeg?auto=compress&cs=tinysrgb&w=1200',
  'solar-ev-charging': 'https://images.unsplash.com/photo-1509391366360-2e959784a276?w=1200&q=80',
  'event-services': 'https://images.unsplash.com/photo-1772127822525-7eda37383b9f?w=1200&q=80',
  'photography-videography': 'https://images.unsplash.com/photo-1745847768366-d44dcef9ef35?w=1200&q=80',
  'catering-food-services': 'https://images.pexels.com/photos/2291367/pexels-photo-2291367.jpeg?auto=compress&cs=tinysrgb&w=1200',
  'equipment-furniture-hire': 'https://images.pexels.com/photos/29188023/pexels-photo-29188023.jpeg?auto=compress&cs=tinysrgb&w=1200',
  'personal-wellness-services': 'https://images.unsplash.com/photo-1545205597-3d9d02c29597?w=1200&q=80',
  'pet-services': 'https://images.pexels.com/photos/6131008/pexels-photo-6131008.jpeg?auto=compress&cs=tinysrgb&w=1200',
  'dj-mc-services': 'https://images.unsplash.com/photo-1574939328375-54ec1bcf27fa?w=1200&q=80',
  'window-tinting': 'https://images.pexels.com/photos/31154212/pexels-photo-31154212.jpeg?auto=compress&cs=tinysrgb&w=1600',
  // New 2026
  'accounting-tax': 'https://images.unsplash.com/photo-1554224155-6726b3ff858f?w=1200&q=80',
  // Premium design workspace: typography "A" sketch, design magazine in HandyHub-brand-orange,
  // stylus, headphones — scored 8/10 premium, brand-aligned palette, no 3rd-party logos
  'signage-printing': 'https://images.unsplash.com/photo-1611532736597-de2d4265fba3?w=1200&q=80',
  // Disassembled iPhone with motherboard + repair tools laid out cleanly on blue mat —
  // scored 9/10 premium, modern, professional repair workshop feel, no 3rd-party logos
  'phone-repair': 'https://images.unsplash.com/photo-1746005514010-e7ab2bc3d210?w=1200&q=80',
};

// Service icon mapping (slug → lucide icon)
export const serviceIconMap = {
  'regular-house-cleaning': Home, 'deep-cleaning': Sparkles, 'office-cleaning': Building2,
  'window-cleaning': Wind, 'carpet-cleaning': Ruler, 'oven-cleaning': Flame,
  'upholstery-cleaning': PenTool, 'end-of-tenancy-clean': CheckCircle,
  'leak-repair': Droplets, 'drain-unblocking': Pipette, 'hot-water-system': Thermometer,
  'toilet-installation': Wrench, 'tap-installation': Droplets, 'gas-fitting': Flame,
  'light-installation': Zap, 'powerpoint-installation': Plug, 'ceiling-fan-installation': Fan,
  'switchboard-upgrade': CircuitBoard, 'smoke-alarm-installation': Shield,
  'electrical-safety-inspection': CheckCircle, 'ev-charger-installation': Zap,
  'tv-mounting': Tv, 'shelf-installation': Ruler, 'door-repair': DoorOpen,
  'picture-hanging': Frame, 'blind-installation': Blinds, 'minor-repairs': Hammer,
  'lock-installation': Lock, 'weatherproofing': CloudRain, 'gutter-cleaning': Droplets,
  'furniture-assembly': Package,
  'lawn-mowing': Leaf, 'hedge-trimming': Scissors, 'garden-maintenance': Flower2,
  'tree-pruning': TreePine, 'garden-design': Flower2, 'irrigation-installation': Waves,
  'property-inspection': CheckCircle, 'deck-fence-maintenance': Fence,
  'pressure-washing': Waves, 'roof-repairs': Home, 'building-maintenance': Building2,
  'washing-machine-repair': WashingMachine, 'fridge-repair': Refrigerator,
  'dishwasher-repair': Droplets, 'dryer-repair': Wind,
  'oven-repair': Flame, 'air-conditioner-service': AirVent,
  'home-moving': Truck, 'office-moving': Truck, 'furniture-removal': Package,
  'packing-services': Package, 'storage-solutions': Warehouse,
  'kitchen-renovation': Home, 'bathroom-renovation': Droplets,
  'flooring-installation': Ruler, 'tiling': HardHat, 'plastering': Paintbrush,
  'general-pest-treatment': Bug, 'termite-inspection': Bug, 'rodent-control': Bug,
  'bee-wasp-removal': Bug, 'flea-treatment': Bug,
  'interior-painting': Paintbrush, 'exterior-painting': Paintbrush,
  'fence-painting': Fence, 'deck-staining': Paintbrush,
  'commercial-painting': Building2, 'wallpaper-installation': PenTool,
  'custom-cabinetry': Hammer, 'deck-building': Fence, 'fence-building': Fence,
  'door-installation': DoorOpen, 'staircase-work': HardHat, 'timber-repairs': Hammer,
  'heat-pump-installation': Wind, 'heat-pump-servicing': Wind, 'air-conditioning-repair': AirVent,
  'ducted-system-installation': Wind, 'ventilation-hrv-systems': AirVent, 'heat-pump-removal': Wind,
  'mobile-hairdresser': Scissors, 'makeup-artist': Sparkles, 'nail-technician': Sparkles,
  'eyelash-extensions': Sparkles, 'massage-therapy': Heart, 'spray-tan': Sparkles,
  'computer-repair': CircuitBoard, 'wifi-network-setup': CircuitBoard, 'smart-home-setup': CircuitBoard,
  'data-recovery': CircuitBoard, 'website-development': CircuitBoard, 'it-support-troubleshooting': CircuitBoard,
  'cctv-installation': Lock, 'alarm-system-installation': Lock, 'security-lighting': Lock,
  'intercom-access-control': Lock, 'security-patrol-monitoring': Shield, 'cctv-maintenance-upgrade': Lock,
  'timber-floor-installation': Frame, 'vinyl-laminate-flooring': Frame, 'carpet-installation': Frame,
  'tile-installation': Frame, 'floor-sanding-polishing': Frame, 'floor-repair': Frame,
  'roof-repair': CloudRain, 'gutter-cleaning-service': CloudRain, 'gutter-guard-installation': CloudRain,
  'roof-painting': CloudRain, 're-roofing': CloudRain, 'spouting-downpipe-replacement': CloudRain,
  'ai-chatbot-development': Sparkles, 'ai-automation-setup': Sparkles, 'ai-content-generation': Sparkles,
  'machine-learning-consulting': Sparkles, 'ai-integration-business': Sparkles, 'data-analysis-insights': Sparkles,
  'mobile-car-service': Truck, 'wof-inspection': Truck, 'brake-repair-replacement': Truck,
  'battery-replacement': Truck, 'tyre-fitting-alignment': Truck, 'pre-purchase-vehicle-inspection': Truck,
  'pool-cleaning-maintenance': Waves, 'pool-pump-filter-repair': Waves, 'spa-pool-servicing': Waves,
  'pool-resurfacing': Waves, 'pool-fence-installation': Fence, 'pool-opening-closing': Waves,
  'timber-fence-installation': Fence, 'fence-repair': Fence, 'aluminium-fencing': Fence,
  'automatic-gate-installation': Fence, 'retaining-wall-construction': HardHat, 'gate-repair-adjustment': Fence,
  'emergency-lockout': Lock, 'lock-replacement': Lock, 'key-cutting': Lock,
  'smart-lock-installation': Lock, 'master-key-system': Lock, 'safe-opening-installation': Lock,
  'solar-panel-installation': Zap, 'battery-storage-system': Zap,
  'solar-panel-cleaning': Zap, 'solar-system-inspection': Zap, 'hot-water-heat-pump': Zap,
  // Event Services
  'event-decorator': Sparkles, 'wedding-decorator': Sparkles, 'birthday-party-setup': Sparkles,
  'balloon-decoration': Sparkles, 'stage-setup--styling': Sparkles, 'floral-decoration': Flower2,
  'lighting--effects': Sparkles, 'mandap-setup': Sparkles,
  // Photography & Videography
  'event-photographer': Frame, 'wedding-photographer': Frame, 'videographer': Frame,
  'drone-photography': Frame, 'photo-editing-services': Frame, 'content-creator': Frame,
  // Catering & Food Services
  'event-catering': Flame, 'wedding-catering': Flame, 'private-chef': Flame,
  'bbq-catering': Flame, 'bartender-services': Flame, 'food-truck-catering': Truck,
  // Equipment & Furniture Hire
  'marquee-hire': Package, 'tent-hire': Package, 'table-hire': Package,
  'chair-hire': Package, 'event-furniture-hire': Package, 'sound-system-hire': Package,
  'lighting-equipment-hire': Package, 'outdoor-heater-hire': Package,
  // Personal & Wellness
  'personal-trainer': Heart, 'yoga-instructor': Heart, 'tutor-services': Heart, 'life-coaching': Heart,
  // Pet Services
  'dog-walking': Leaf, 'pet-grooming': Scissors, 'pet-sitting': Leaf,
  // DJ & MC
  'dj-services': Sparkles, 'wedding-dj': Sparkles, 'party-dj': Sparkles,
  'corporate-event-dj': Sparkles, 'mc-services': Sparkles, 'wedding-mc': Sparkles,
  // Hair & Beauty (new)
  'hairdresser-salon-services': Scissors,
  // ── Accounting & Tax Services (2026) ──
  'tax-returns': Receipt, 'gst-filing': Receipt, 'bookkeeping': Calculator,
  'payroll-services': Coins, 'paye-services': FileText, 'company-registration': Briefcase,
  'xero-setup-and-support': Calculator, 'small-business-accounting': PieChart,
  'financial-statements': PieChart, 'tax-consultation': Banknote,
  'ird-assistance': Landmark, 'invoice-and-expense-management': Receipt,
  'budgeting-and-cashflow-planning': PieChart,
  // ── Signage & Printing (2026) ──
  'shop-signage': Tag, 'vehicle-sign-writing': Truck, 'business-cards-printing': Tag,
  'flyers-and-brochures': FileText, 'banner-printing': Megaphone, 'window-graphics': Frame,
  'vinyl-stickers': Sticker, 'led-signs': Zap, 'promotional-printing': Megaphone,
  't-shirt-printing': Shirt, 'poster-printing': Image, 'pull-up-banners': Megaphone,
  'corflute-signs': Tag,
  // ── Phone & Electronics Repair (2026) ──
  'mobile-screen-repair': Smartphone, 'battery-replacement': Battery,
  'charging-port-repair': BatteryCharging, 'iphone-repairs': Smartphone,
  'android-repairs': Smartphone, 'tablet-repairs': Tablet,
  'data-transfer': Smartphone, 'water-damage-repair': Droplets,
};

export const FALLBACK_IMG = "https://images.unsplash.com/photo-1581783898377-1c85bf937427?w=800&q=80";
export const handleImgError = (e) => { e.target.src = FALLBACK_IMG; };

export const getServiceGradient = (service) => {
  const catSlug = service?.category?.slug || service?.categories?.slug || '';
  return categoryGradients[catSlug] || 'cleaning';
};
